import React from "react";
import { SunIcon, MoonIcon } from "@heroicons/react/24/outline";
import { useTheme } from "../theme/ThemeProvider";

/**
 * Switches between light and dark. The app boots in "system" mode; the first
 * press pins an explicit choice, which then survives reloads.
 */
export default function ThemeToggle({ className = "" }) {
  const { resolved, toggle } = useTheme();
  const goingDark = resolved === "light";

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={goingDark ? "Switch to dark theme" : "Switch to light theme"}
      title={goingDark ? "Switch to dark theme" : "Switch to light theme"}
      className={
        "inline-flex h-10 w-10 items-center justify-center rounded-md border " +
        "border-subtle text-fg-secondary transition-colors duration-fast ease-standard " +
        "hover:bg-bg-muted hover:text-fg " +
        className
      }
    >
      {goingDark ? (
        <MoonIcon className="h-5 w-5" aria-hidden="true" />
      ) : (
        <SunIcon className="h-5 w-5" aria-hidden="true" />
      )}
    </button>
  );
}
